
import { throwError as observableThrowError, Observable, empty } from 'rxjs';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent,
  HttpResponse, HttpUserEvent, HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HOST, baseHOST, DATACENTER, IMPORT, INSPECTION, ADMINISTRATION } from '../../routes';
import { AuthService } from '../auth-service/auth.service';
import { Router } from '@angular/router';
import { switchMap, catchError, first } from 'rxjs/operators';

/*
* Class for the AuthInterceptor interceptor.
*/
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  // tokenRefreshed$ = this.tokenRefreshedSource.asObservable();

  constructor(private authService: AuthService, private router: Router) { }

  updateRequestHeaders(request: HttpRequest<any>): HttpRequest<any> {
    if (this.authService.authorizationHeader) {
      return request.clone({
        setHeaders: {
		  Authorization: this.authService.authorizationHeader,
          Accept: 'application/json',
        },
      });
    }
    return request;
  }

  refreshTokens() {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent |
    HttpResponse<any> | HttpUserEvent<any>> {
    // TODO: FIX REFRESHTOKEN NAVIGATION IN INTERCEPTOR
    if (req.url.startsWith(HOST) || req.url.startsWith(DATACENTER) || req.url.startsWith(IMPORT) || req.url.startsWith(INSPECTION) || req.url.startsWith(ADMINISTRATION)) {
	  const updatedRequest = this.updateRequestHeaders(req);
      if (updatedRequest) {
        return next.handle(updatedRequest).pipe(catchError(err => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              if (this.authService.refreshInProgress === false) {
                return this.authService.refreshAccessToken().pipe(switchMap(result => {
                  if (result.ok) {
                    console.log('refresh successful!');
                    return this.intercept(req, next);
                  } else {
                    this.router.navigate(['/login']);
                    console.log('refresh not successful!');
                    return observableThrowError('refreshNotSuccessful!');
                  }
                }));
              } else {
                console.log('wait for refresh!!');
                return this.authService.tokenRefreshSubject.pipe(first(), switchMap(success => {
                  console.log('done waiting for refresh');
                  if (success === true) {
                    console.log('restart interception!');
                    return this.intercept(req, next);
                  } else {
                    console.log('refresh not successful!');
                    this.router.navigate(['/login']);
                    return observableThrowError('refreshNotSuccessful!');
                  }
                }));
              }
            }
            //  else {
            //   console.log('refresh not successful!');
            //   this.router.navigate(['/login']);
            //   return observableThrowError('refreshNotSuccessful!');
            // }
          }
          // this.router.navigate(['/login']);
          console.log('Error is thrown!');
          return observableThrowError(err);
        }));
      } else {
        console.log('Cancel Request at this point');
        this.router.navigate(['/login']);
        return empty();
      }
    }
    return next.handle(req);
  }



  // handle401(req: HttpRequest<any>, next: HttpHandler, ) {
  //   if ( this.refreshTokenInProgress ) {

  //     // If refresh is currently in progress subscribe requests to the behaviorsubject to wait for further action
  //     // filter for successful token update and emit one value

  //     this.tokenRefreshedSubject.next(false);
  //     this.tokenRefreshedSubject.filter((success, index) => {
  //       console.log('RefreshSubject value: ' + success);
  //       console.log('RefreshSubject index: ' + index);
  //       return success === true;
  //     }).take(1).switchMap((success, index) => {
  //       return next.handle(this.updateRequestHeaders(req));
  //     });
  //   } else {
  //     this.refreshTokenInProgress = true;
  //     this.authService.refreshAccessToken().subscribe(success => {
  //       this.refreshTokenInProgress = false;
  //       if (success) {
  //         this.tokenRefreshedSubject.next(true);
  //         return next.handle(this.updateRequestHeaders(req));
  //       } else {
  //         // failed to Refresh Token, handle Error;
  //         this.tokenRefreshedSubject.next(false);
  //         this.tokenRefreshedSubject.complete();
  //         // TODO: Trigger Logout Navigation
  //       }
  //       });
  //   }
  // }

	// intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
	// 	if (req.url.startsWith(HOST)) {
	// 		// Handle request
	// 		req = this.addAuthHeader(req);

	// 		// Handle response
	// 		return next.handle(req).catch(error => {
	// 			if (error.status === 401) {
	// 				return this.refreshToken()
	// 					.switchMap(() => {
	// 						req = this.addAuthHeader(req);
	// 						return next.handle(req);
	// 					})
	// 					.catch(() => {
	// 						return Observable.empty();
	// 					});
	// 			}

	// 			return Observable.throw(error);
	// 		});
	// 	} else {
	// 		return next.handle(req);
	// 	}
	// }

	// /**
	//  * Adds an authorization header to the request
	//  * @param request HttpRequest
	//  * @return HttpRequest
	//  */
	// private addAuthHeader(request: HttpRequest<any>): HttpRequest<any> {
	// 	const authHeader = this.authService.authorizationHeader;
	// 	if (authHeader) {
	// 		return request.clone({
	// 			headers: request.headers.set('Authorization', authHeader),
	// 		});
	// 	}
	// 	return request;
	// }

	// /**
	//  * Refresh token
	//  * @return
	//  */
	// private refreshToken(): Observable<any> {
	// 	if (this.refreshTokenInProgress) {
	// 		return new Observable(observer => {
	// 			this.tokenRefreshed$.subscribe(() => {
	// 				observer.next();
	// 				observer.complete();
	// 			});
	// 		});
	// 	} else {
	// 		this.refreshTokenInProgress = true;

	// 		return this.authService.refresh().do(() => {
	// 			this.refreshTokenInProgress = false;
	// 			this.tokenRefreshedSource.next();
	// 		});
	// 	}
	// }
}
